import { render, staticRenderFns } from "./newmaterialintegralrule.vue?vue&type=template&id=64096b1a&"
import script from "./newmaterialintegralrule.vue?vue&type=script&lang=js&"
export * from "./newmaterialintegralrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports